export const toElipsis = (value: string) => (value.length > 2 ? "..." : value);
